/* psnm-basket-panel.js - 6 Oct 2026, basket C: the floating "Your basket" panel is OFF.
   MM decision: the basket lives in the cart drawer and on /cart only. This file no longer builds the
   .psnm-bk-float panel, injects its styles, or wraps window.fetch. What remains is the float placement
   routine, unchanged, because it also positions the Subscribe seal (.psnm-pawfab) below the header on
   desktop. With no panel on the page it only ever touches the seal.
   Revert: restore assets/psnm-basket-panel.bak-6oct2026.js. */
(function(){
  /* --- Float placement. Measured ONCE, in document coordinates. No scroll listener. --- */
  var PSNM_FLOAT_GAP = 14;
  var PSNM_FLOAT_MIN = 96;
  function psnmHeaderBottomDoc(){
    var h=document.getElementById('HeaderWrapper')||document.querySelector('.header-wrapper')||document.querySelector('.site-header')||document.querySelector('header');
    if(!h)return null;
    var y=window.pageYOffset||document.documentElement.scrollTop||0;
    return Math.round(h.getBoundingClientRect().bottom+y);
  }
  function psnmPlaceFloats(){
    var seal=document.querySelector('.psnm-pawfab');
    var bk=document.querySelector('.psnm-bk-float');
    if(window.innerWidth<769){
      if(seal){seal.style.top='';seal.style.bottom='';}
      if(bk){bk.style.top='';bk.style.bottom='';}
      return;
    }
    var b=psnmHeaderBottomDoc();
    var t=(b==null)?PSNM_FLOAT_MIN:(b+PSNM_FLOAT_GAP);
    if(!isFinite(t)||t<PSNM_FLOAT_MIN)t=PSNM_FLOAT_MIN;
    var top=t+'px';
    if(seal){seal.style.top=top;seal.style.bottom='auto';}
    if(bk){bk.style.top=top;bk.style.bottom='auto';}
  }
  var _psnmFT;
  function psnmScheduleFloats(){clearTimeout(_psnmFT);_psnmFT=setTimeout(psnmPlaceFloats,120);}
  if(document.readyState!=='loading')psnmPlaceFloats();else document.addEventListener('DOMContentLoaded',psnmPlaceFloats);
  window.addEventListener('load',psnmPlaceFloats);
  window.addEventListener('resize',psnmScheduleFloats);
  document.addEventListener('shopify:section:load',psnmScheduleFloats);
})();
